import datapoints from './datapoints';
import restoreConversationService from '../services/restoreConversationService';
import { getApplyConversationActionContext, getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { getStore } from 'owa-mail-list-store/lib/store/Store';
import filterConversationRowsByRestriction from 'owa-mail-list-store/lib/utils/filterConversationRowsByRestriction';
import { actionNames, DeleteConversationStoreUpdate } from 'owa-mail-store-actions';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { processApplyConversationActionResponseMessage } from 'owa-mail-triage-action-response-processor';

/**
 * Restore conversations action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @return the action response
 */
export default createLegacyActionWithDatapoint(
    'RestoreConversation',
    datapoints.restoreConversation
)(function restoreConversations(conversationRowKeys: string[], tableViewId: string): Promise<void> {
    const tableView = getStore().tableViews.get(tableViewId);
    const filteredRowKeys = filterConversationRowsByRestriction(
        conversationRowKeys,
        tableViewId,
        tableConversationRelation => !!tableConversationRelation
    );

    const conversationIdStrings = getRowIdsFromRowKeys(filteredRowKeys, tableViewId);
    const conversationActionContexts = filteredRowKeys.map(rowKey =>
        getApplyConversationActionContext(rowKey, tableViewId)
    );

    // 1. Make local update
    raiseAction<
        DeleteConversationStoreUpdate
    >(actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, tableView);

    // 2. Make service request
    // When restoring conversation we should act upon folderId and not on serverFolderId
    // so that entire conversation and not just the items belonging to the serverFolderId gets restored
    const contextFolderId = tableView.tableQuery.folderId;
    const restoreConversationPromise = restoreConversationService(
        conversationActionContexts,
        contextFolderId
    );

    return processApplyConversationActionResponseMessage(
        restoreConversationPromise,
        filteredRowKeys,
        tableView.serverFolderId,
        tableView,
        false /* shouldRemoveRowsFromTombstone */
    );
});
